// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grey_button {
  color: white;
  height: 50px;
  padding: 10px 20px;
  border-radius: 16px;
  background: #222423;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 1s;
}
.grey_button:hover {
  background: rgba(34, 36, 35, 0.5);
}
.grey_button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.grey_navigation_link {
  background: #373A39;
}

.color_button {
  padding: 13px 30px;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  height: 50px;
  background: linear-gradient(to right, #F08319, #E51B2F);
  color: white;
  transition: all 1s;
}
.color_button:hover {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/UI.sass"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AACF;AAAE;EACE,iCAAA;AAEJ;AADE;EACE,mBAAA;EACA,YAAA;AAGJ;;AADA;EACE,mBAAA;AAIF;;AAHA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,uDAAA;EACA,YAAA;EACA,kBAAA;AAMF;AALE;EACE,YAAA;AAOJ","sourcesContent":[".grey_button\n  color: white\n  height: 50px\n  padding: 10px 20px\n  border-radius: 16px\n  background: #222423\n  border: none\n  cursor: pointer\n  font-size: 14px\n  transition: all 1s\n  &:hover\n    background: rgba(34, 36, 35, 0.5)\n  &:disabled\n    cursor: not-allowed\n    opacity: 0.4\n\n.grey_navigation_link\n  background: #373A39\n.color_button\n  padding: 13px 30px\n  border-radius: 16px\n  border: none\n  cursor: pointer\n  font-size: 14px\n  height: 50px\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  color: white\n  transition: all 1s\n  &:hover\n    opacity: 0.5"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
